module.exports = __webpack_public_path__ + "static/media/ouveo.1e5d5afd.jpg";